import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18433222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card ss-fadein" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ss-div-icone-etapa" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-icone-etapa",
    img: "",
    src: "/static/img/configuracao-inicial/icone-vendas.png"
  })
], -1))
const _hoisted_4 = { class: "ant-col ss-div-conteudo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Seu processo de vendas personalizado", -1))
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"5px"}
}
const _hoisted_7 = {
  key: 0,
  class: "ant-row ss-div-switch"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar o processo de vendas padrão", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar um processo de vendas", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "ant-row ss-div-switch"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Vou usar o cliente 'Consumidor Final'", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Criar um cliente", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  class: "ant-row",
  style: {"margin-top":"5px"}
}
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-col ss-div-icone-etapa" }
const _hoisted_22 = {
  key: 0,
  class: "ss-icone-etapa ss-fadein",
  img: "",
  src: "/static/img/configuracao-inicial/icone-feito.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_processo_vendas_modal = _resolveComponent("processo-vendas-modal")!
  const _component_pessoa_modal = _resolveComponent("pessoa-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.computedConfiguracao.etapaAtual === _ctx.EEtapaConfiguracaoInicial.Vendas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.state.permissaoProcessoVendas)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_a_switch, {
                      class: "ss-switch",
                      checked: _ctx.computedConfiguracao.usarProcessoVendasPadrao,
                      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedConfiguracao.usarProcessoVendasPadrao) = $event))
                    }, null, 8, ["checked"]),
                    (_ctx.computedConfiguracao.usarProcessoVendasPadrao)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirProcessoVendas && _ctx.abrirProcessoVendas(...args)))
                        }, _hoisted_12))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.permissaoCliente)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_a_switch, {
                      class: "ss-switch",
                      checked: _ctx.computedConfiguracao.usarClientePadrao,
                      "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedConfiguracao.usarClientePadrao) = $event))
                    }, null, 8, ["checked"]),
                    (_ctx.computedConfiguracao.usarClientePadrao)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.abrirCliente && _ctx.abrirCliente(...args)))
                        }, _hoisted_18))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.state.concluindo)
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 0,
                  description: "Lançando novos registros isso pode demorar um pouco.",
                  style: {"white-space":"pre"},
                  type: "info",
                  "show-icon": ""
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.computedConfiguracao.etapaAtual !== _ctx.EEtapaConfiguracaoInicial.Vendas)
          ? (_openBlock(), _createElementBlock("img", _hoisted_22))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "ss-botao-concluir",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.concluir && _ctx.concluir(...args)))
            }, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.carregando
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Concluir!")
                ]),
                _: 1
              }, 8, ["spinning"])
            ]))
      ])
    ]),
    _createVNode(_component_processo_vendas_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirProcessoVendas,
      "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.exibirProcessoVendas) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_pessoa_modal, {
      "servico-a-p-i": _ctx.servicoCliente,
      tituloModal: "Cadastro de Clientes",
      "relacao-principal-operacao": _ctx.ETipoRelacaoPessoa.Cliente,
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirCliente,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.exibirCliente) = $event))
    }, null, 8, ["servico-a-p-i", "relacao-principal-operacao", "operacao", "visivel"])
  ]))
}